import React, {ChangeEvent, FC} from "react";
import _ from "lodash";
import { HeaderModel } from "../../../../models/CommonModel";
import { formatPrice } from "../../../../selectors";
import SortableColumn from "../../../../components/Table/SortableColumn";
import { IInventoryOfSento } from "../../../../models/AgentProduct";
import { ImportRequestDetailModel } from "../../../../models/ImportRequestModel";
import { removeTrailingZeros } from "../../../../modules/common/helper";

type TProps = {
  products?: IInventoryOfSento[],
  placedProducts: any,
  headers: HeaderModel[],
  hideCols: string[],
  handleChangeQty: (e: ChangeEvent<HTMLInputElement>, item: IInventoryOfSento) => void,
  toggleCheck: (e: ChangeEvent<HTMLInputElement>, item: IInventoryOfSento) => void,
  openColConfig: () => void,
  handleCheckAll?: (e: any) => void,
  handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
}

const ProductTable: FC<TProps> = ({
    products,
    headers,
    hideCols,
    openColConfig,
    handleCheckAll,
    placedProducts,
    handleSort,
    handleChangeQty,
    toggleCheck
  }) => {

  const isCheckedAllF = () => {
    return products?.every(itemB => placedProducts.some((itemA: ImportRequestDetailModel) => itemA.inventory_of_supplier_id === itemB.best_supplier?.id));
  }
  const classTable = Object.keys(placedProducts).length ? '' : ' table-hover table-striped '
  const isCheckedAll = isCheckedAllF();
  return <>
    <div className='table-responsive mt-5'>
      <table className={`table table-bordered border gy-7 gs-7 ${classTable}`}>
        <thead>
        <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
          <th>
            <i
              className="fa fa-cogs"
              style={{cursor: 'pointer'}}
              onClick={openColConfig}
            ></i>
          </th>
          <th>
            <input key={`checked_all_${isCheckedAll}`} className="form-check-input" type="checkbox" role="button"
              value=""
              checked={isCheckedAll}
              onChange={handleCheckAll} />
          </th>
          {headers.map((th, index) => {
            if (!hideCols.includes(th.field)) {
              if (th.sortable) {
                return (
                  <SortableColumn
                    key={'th-' + index}
                    sortBy={th?.field}
                    onSortChange={handleSort}
                    style={th?.style ?? {}}
                  >
                    {th.label}
                  </SortableColumn>
                )
              }
              return (
                <th key={'th-' + index} style={th?.style ?? {}}>{th.label}</th>
              )
            }
          })}
        </tr>
        </thead>
        <tbody>
        {products?.map((item: IInventoryOfSento, index: number) => {
          let iSupplier = item.best_supplier;
          let checked = _.find(placedProducts, function (e: ImportRequestDetailModel) {
            return e.inventory_of_supplier_id === iSupplier?.id;
          })
          let warehouse = iSupplier?.warehouse;
          return (
            <tr key={`order_product_${index}_${item.id}`} className={`cursor-pointer`}>
              <td></td>
              <td>
                  <div className="form-check form-check-custom">
                    <input key={`item_checkbox_${item.id}_${!!checked}`} className="form-check-input" type="checkbox"
                        value={item.id}
                        defaultChecked={!!checked}
                        name="checked"
                        onChange={(e) => toggleCheck(e, item)}/>
                  </div>
              </td>
              {!hideCols.includes('name') && (
                <td>
                  {item.name}
                </td>
              )}
              {!hideCols.includes('supplier_name') && (
                <td>
                  {iSupplier?.supplier?.name ?? ''}
                </td>
              )}
              {!hideCols.includes('supplier_price') && (
                <td >
                    {formatPrice(iSupplier?.price ?? 0)}
                </td>
              )}
              {!hideCols.includes('quantity') && (
                <td className="">
                  <div className="input-group input-group-sm mb-3 ">
                    <input className="form-control form-control-sm"  key={`receipt_quantity_${item.id}`}
                          min={0} 
                          type="number"
                          defaultValue={0}
                          value={checked?.quantity ?? 0}
                          name="quantity"
                          onChange={(e) => handleChangeQty(e, item)}
                          onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}

                    />
                    <span className="input-group-text text-sm-center">{item?.units?.name || ""}</span>
                  </div>
                </td>
              )}
              {!hideCols.includes('vat') && (
                <td>
                  <div className="input-group input-group-sm mb-3 ">
                    {item?.vat ?? 0}%
                  </div>
                </td>
              )}
              {!hideCols.includes('warehouse') && (
                <td>
                  {removeTrailingZeros(warehouse?.quantity ?? 0)}
                </td>
              )}
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>
  </>
}
export default ProductTable